// src/utils/QuillExtensions.js
import Quill from 'react-quill';

const getQuillConstructor = () => {
  if (Quill && Quill.Quill) {
    return Quill.Quill;
  }
  if (window.Quill) {
    return window.Quill;
  }
  console.error('Quill constructor not found');
  return null;
};

const initQuillExtensions = () => {
  try {
    console.log('Initializing Quill extensions...');
    
    const QuillConstructor = getQuillConstructor();
    
    if (!QuillConstructor) {
      console.error('Could not find Quill constructor');
      return false;
    }
    
    console.log('Quill constructor found:', typeof QuillConstructor);    
      
    if (QuillConstructor.imports && !QuillConstructor.imports['formats/callout']) {
      try {
        const Inline = QuillConstructor.import('blots/inline');
        
        if (!Inline) {
          console.error('Could not import Inline blot from Quill');
          return false;
        }
        
        class CalloutBlot extends Inline {
          static create() {
            const node = super.create();
            node.classList.add('ql-callout');
            node.style.backgroundColor = '#f0f8ff';
            node.style.color = '#0066cc';
            node.style.padding = '0 4px';
            node.style.borderBottom = '1px dotted #0066cc';
            node.style.cursor = 'pointer';
            return node;
          }
        }
        
        CalloutBlot.blotName = 'callout';
        CalloutBlot.tagName = 'span';
        CalloutBlot.className = 'ql-callout';
        
        QuillConstructor.register(CalloutBlot);
        console.log('CalloutBlot registered successfully');
      } catch (calloutError) {
        console.error('Error registering CalloutBlot:', calloutError);
      }
    } else {
      console.log('CalloutBlot is already registered or imports not available');
    }
    
    console.log('Quill extensions initialized successfully');
    return true;
  } catch (error) {
    console.error('Error in initQuillExtensions:', error);
    return false;
  }
};

export default initQuillExtensions;
